export default "__VITE_ASSET__CGKPSqSi__"